import React from 'react'
import Bredcom from '../../Bredcom/Main'
import First from '../Menprojectdeatils/First'

function Main() {
  return (
    <>
        <Bredcom title="Gallery Details" subtitle="Home" subtitledown="Pricing"/>
        <First/>
    </>
  )
}

export default Main